import type { Reference } from "../Reference.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getReferenceDetailPath(reference: Pick<Reference, "locale" | "urlSlug">): string {
	return getPathInLocale(reference.locale, `/portfolio/${reference.urlSlug}`);
}
